import React, { memo } from 'react'

import arrow from 'images/three_d_studio/remesh/arrow.webp'

function Preview() {
  return (
    <div className="segment-tab__preview" aria-hidden="true">
      <img
        alt=""
        className="segment-tab__preview-image segment-tab__preview-image--original"
        src="/assets/three_d_studio/segment_tab/elf_original.webp"
        height={234}
        width={181}
      />
      <span className="segment-tab__preview-arrow">
        <img
          src={arrow}
          alt="Arrow"
          width={27}
          height={12}
        />
      </span>
      <img
        alt=""
        className="segment-tab__preview-image segment-tab__preview-image--segmented"
        src="/assets/three_d_studio/segment_tab/elf_segmented.webp"
        height={221}
        width={172}
      />
    </div>
  )
}

export default memo(Preview)
